<div [formGroup]="this.form">
    <label for="contactPerson">Contactperson</label>

    <div class="ng-autocomplete">
        <ng-autocomplete
            [data]="contacts"
            [searchKeyword]="contactKeyword"
            formControlName="contactPerson"
            [initialValue]="this.initialValue"
            autocomplete="off"
            [itemTemplate]="contactPersonTemplate"
            [notFoundTemplate]="contactPersonNotFoundTemplate"
            placeholder="Choose a contact">
        </ng-autocomplete>

        <ng-template
            #contactPersonTemplate
            let-item>
            <a [innerHTML]="item.firstName + ' ' + item.lastName"></a>
        </ng-template>

        <ng-template
            #contactPersonNotFoundTemplate
            let-notFound>
            <p>No contacts found...</p>
        </ng-template>
    </div>

    <button
        class="button button--outline button--icon m-l-12"
        (click)="openAddContactPersonModal()">
        <i class="las la-plus"></i>
    </button>
</div>
